const writeLog = (str) => {
    if (!window.logObj) return;

    var log = str + " [" + (new Date()) + "]\n";

    window.logObj.createWriter(function (fileWriter) {
        fileWriter.seek(fileWriter.length);

        var blob = new Blob([log], {type: 'text/plain'});
        fileWriter.write(blob);
    }, function (data) {
        console.log('FAILED TO WRITE TRACKING LOG', data)
    });
};

const asFile = () => {
  return window.logObj.file(function (file) {
    return file
  }, function () {
    return null;
  });
};

const readLog = (store) => {
  let payload = {};

  window.logObj.file(function (file) {
    var reader = new FileReader();

    reader.onload = function() {
      payload.debug = this.result

      window.trackingLogObj.file(function (file) {
        var reader = new FileReader();

        reader.onload = function() {
          payload.tracking = this.result;
          store.dispatch('pushLogs', payload);
        };

        reader.readAsText(file);

      }, function() {console.error('No tracking logs found')});
    };

    reader.readAsText(file);

  }, function() {console.error('No debug log found')});
}

export {writeLog, readLog, asFile}
